import React, { Component } from "react";
import { Modal, Table, Row, Col, Button, Checkbox, message } from 'antd';
import InputForm from "../components/InputForm";
import "./Pages.css";
import axios from 'axios';

const { Column } = Table;

export default class PermissoesPage extends Component {

  state = {
    selectedRowKeys: [], // Verifique aqui para configurar a coluna padrão
    usuarioSelect: [],
    listaRegistros: [],
    carregando: false,
  };

  start = () => {
    this.setState({ carregando: true });
    // ajax pedido após o preenchimento vazio
    setTimeout(() => {
      this.setState({
        selectedRowKeys: [],
        carregando: false,
      });
    }, 1000);
  }

  componentDidUpdate(antProps, antState) {

  }

  componentDidMount() {
    this.buscaUsuario();
  }

  buscaUsuario = (value) => {
    this.setState({
      usuarioSelect: [],
      carregando: false,
      habilitaBtnGravar: false,
    });
    axios.get('/grupos_usuarios/lista', {
      params: {
        vendedor: 'X'
      }
    }).then(response => {
      const { data } = response;
      const usuarioSelect = data.map(regList => {
        return {
          key: regList.gu_idf,
          label: regList.gu_descricao
        }
      });
      this.setState({
        usuarioSelect,
      })

    }).catch(error => {
      console.error(error.response);
    })
  }

  onChangeUsuario = event => {
    this.setState({
      usuario: event.target.value,
    });

    this.getListaRegistros(event.target.value.key);
  };


  getListaRegistros = (value) => {
    this.setState({ carregando: true, listaRegistros: [], habilitaBtnGravar: false });

    axios
      .get('/usuarios/listaPermissoes', {
        params: {
          grupo: value,
        }
      })
      .then(response => {
        this.setState({
          listaRegistros: response.data,
          carregando: false,
          habilitaBtnGravar: true,
        });
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        });
      });
  };


  onGravarClick = () => {
    const { listaRegistros, usuario } = this.state;
    this.setState({ carregando: true })

    axios.put(`/usuarios/updatePermissoes/${usuario.key}`, {
      listaRegistros
    })
      .then(response => {
        this.setState({
          carregando: false,
          listaRegistros: [],
          habilitaBtnGravar: false,
        });
        message.success('Permissões gravadas com sucesso.');
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
        Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
      })
  };


  onSelectChange = (selectedRowKeys) => {
    this.setState({ selectedRowKeys });
  }

  onChangeConsultar(e, registro) {
    registro.pg_consultar = e.target.checked;
    this.forceUpdate();
  }

  onChangeNovo(e, registro) {
    registro.pg_novo = e.target.checked;
    this.forceUpdate();
  }

  onChangeEditar(e, registro) {
    registro.pg_editar = e.target.checked;
    this.forceUpdate();
  }

  onChangeExcluir(e, registro) {
    registro.pg_excluir = e.target.checked;
    this.forceUpdate();
  }



  renderCheckConsultar = (pg_consultar, registro) => {
    return (
      <Checkbox
        checked={pg_consultar}
        onChange={(event) => this.onChangeConsultar(event, registro)}
      />
    );
  };

  renderCheckNovo = (pg_novo, registro) => {
    return (
      <Checkbox
        checked={pg_novo}
        onChange={(event) => this.onChangeNovo(event, registro)}
      />
    );
  };

  renderCheckEditar = (pg_editar, registro) => {
    return (
      <Checkbox
        checked={pg_editar}
        onChange={(event) => this.onChangeEditar(event, registro)}
      />
    );
  };

  renderCheckExcluir = (pg_excluir, registro) => {
    return (
      <Checkbox
        checked={pg_excluir}
        onChange={(event) => this.onChangeExcluir(event, registro)}
      />
    );
  };


  onGravarConceder = () => {
    const { listaRegistros } = this.state;
    for (let i = 0; i < listaRegistros.length; i++) {
      const registro = listaRegistros[i];
      registro.pg_consultar = true;
      registro.pg_editar = true;
      registro.pg_excluir = true;
      registro.pg_novo = true;
    }
    this.setState({
      listaRegistros
    })
  }

  onGravarRevogar = () => {
    const { listaRegistros } = this.state;
    for (let i = 0; i < listaRegistros.length; i++) {
      const registro = listaRegistros[i];
      registro.pg_consultar = false;
      registro.pg_editar = false;
      registro.pg_excluir = false;
      registro.pg_novo = false;
    }
    this.setState({
      listaRegistros
    })
  }



  onGravarClick = () => {
    const { listaRegistros, usuario } = this.state;

    this.setState({
      carregando: true,
    })

    axios.put(`/usuarios/updatePermissoes/${usuario.key}`, {
      listaRegistros
    })
      .then(response => {
        this.setState({
          carregando: false,
          // habilitaBtnGravar: false,
        });
        message.success('Permissões gravadas com sucesso.');
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
        Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
      })
  };


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { carregando, usuarioSelect, listaRegistros, usuario,
      habilitaBtnGravar } = this.state;

    // console.log('PermissoesPage.this.state: ', this.state);

    return (

      <Row>
        <div className="contentRoutesContainer">
          <span className="tituloPage">Permissões dos Usuários para o Sistema</span>
          <div className="divider-page" />

          <div className="pageFiltro">
            <div className="avaliacoesPageFiltro">
              <form onSubmit={this.onBuscar}>
                <Row>

                  <Col xs={24} sm={8}>
                    <InputForm
                      type="select"
                      id="usuario"
                      ref="usuario"
                      value={usuario}
                      placeholder="Selecione o Grupo de Usuário"
                      onChange={this.onChangeUsuario}
                      data={usuarioSelect}
                      validator={value => Boolean(value)}
                      errorMessage="Informe o Grupo de Usuário"
                      showSearch
                    />
                  </Col>


                  <Col xs={24} sm={3} style={{ marginTop: 4, marginLeft: 10 }}>
                    <Button
                      type="ghost"
                      disabled={!habilitaBtnGravar}
                      onClick={this.onGravarConceder}
                    >
                      Conceder Tudo
                  </Button>
                  </Col>


                  <Col xs={24} sm={3} style={{ marginTop: 4, marginLeft: 10 }}>
                    <Button
                      type="ghost"
                      disabled={!habilitaBtnGravar}
                      onClick={this.onGravarRevogar}
                    >
                      Revogar Tudo
                  </Button>
                  </Col>

                  <Col xs={24} sm={3} style={{ marginTop: 4, marginLeft: 20 }}>
                    <Button
                      type="primary"
                      disabled={!habilitaBtnGravar}
                      onClick={this.onGravarClick}
                    >
                      Salvar Permissões
                  </Button>
                  </Col>

                </Row>
              </form>
            </div>

          </div>

          <div>
            <Table
              dataSource={listaRegistros}
              size="middle"
              rowKey={(registro => registro.pp_permissao)}
              onChange={this.onTabelaChange}
              loading={{
                spinning: carregando,
                tip: 'Carregando. Aguarde...',
                size: "large"
              }}
              pagination={false}
            >
              <Column
                key="pp_descricao"
                dataIndex="pp_descricao"
                title="Descrição das Permissões"
                width={"50%"}
                align="left"
              />

              <Column
                key="pg_consultar"
                dataIndex="pg_consultar"
                title="Consultar"
                render={this.renderCheckConsultar}
                width={"10%"}
                align="center"
              />

              <Column
                key="pg_novo"
                dataIndex="pg_novo"
                title="Novo"
                render={this.renderCheckNovo}
                width={"10%"}
                align="center"
              />
              <Column
                key="pg_editar"
                dataIndex="pg_editar"
                title="Editar"
                render={this.renderCheckEditar}
                width={"10%"}
                align="center"
              />
              <Column
                key="pg_excluir"
                dataIndex="pg_excluir"
                title="Excluir"
                render={this.renderCheckExcluir}
                width={"10%"}
                align="center"
              />

            </Table>
          </div>
        </div>
      </Row>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/PermissoesPage.js